/**
 * @generated SignedSource<<ade44c1982f065da48eed65e2270b47c>>
 * @relayHash 08a739f418dfd491c72dff2c2b09a544
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 200ea0ec6cd360b252bf993a3f23c80e1f31a979f9f98b01123bd65473ec8d99

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiBrandingQuery } from './uiBrandingQuery.graphql';

const node: PreloadableConcreteRequest<uiBrandingQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "200ea0ec6cd360b252bf993a3f23c80e1f31a979f9f98b01123bd65473ec8d99",
    "metadata": {},
    "name": "uiBrandingQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
